import React, { useEffect, useState } from 'react';
import { Box, Container, Typography } from '@mui/material';
import { useLocation } from 'react-router-dom';
import MarketOverview from './MarketOverview';
import SearchCompany from './SearchCompany';
import ByIndustry from './ByIndustry';
import Methodology from './Methodology';
// import { useCountry } from '../context/CountryContext';

import Header from '../components/Dashboard/Header';

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          {children}
        </Box>
      )}
    </div>
  );
}

const Dashboard: React.FC = () => {
  // const { country } = useCountry();
  const [selectedTab, setSelectedTab] = useState(0);
  const location = useLocation();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const tabParam = params.get('tab');
    const normalizedPath = location.pathname.replace(/\/+$/, '') || '/';
    let nextTab: number | null = null;

    if (normalizedPath === '/' || normalizedPath === '/market') {
      nextTab = 0;
    } else if (normalizedPath === '/company' || normalizedPath.startsWith('/company/')) {
      nextTab = 1;
    } else if (normalizedPath === '/industry' || normalizedPath.startsWith('/industry/')) {
      nextTab = 2;
    } else if (normalizedPath === '/methodology') {
      nextTab = 3;
    } else if (tabParam === 'search' || tabParam === 'company' || tabParam === '1') {
      nextTab = 1;
    } else if (tabParam === 'industry' || tabParam === '2') {
      nextTab = 2;
    } else if (tabParam === 'methodology' || tabParam === '3') {
      nextTab = 3;
    } else if (tabParam === 'overview' || tabParam === '0') {
      nextTab = 0;
    }

    if (nextTab !== null && nextTab !== selectedTab) {
      setSelectedTab(nextTab);
    }
  }, [location.search, location.pathname, selectedTab]);

  return (
    <Box sx={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
      <Header selectedTab={selectedTab} onTabChange={(index) => setSelectedTab(index)} />
      <Container maxWidth="xl" sx={{ mt: { xs: 12, md: 14 }, mb: 6, flexGrow: 1 }}>
        <TabPanel value={selectedTab} index={0}>
          <MarketOverview />
        </TabPanel>
        <TabPanel value={selectedTab} index={1}>
          <SearchCompany />
        </TabPanel>
        <TabPanel value={selectedTab} index={2}>
          <ByIndustry />
        </TabPanel>
        <TabPanel value={selectedTab} index={3}>
          <Methodology />
        </TabPanel>
      </Container>
      <Box sx={{ borderTop: '1px solid', borderColor: 'grey.200', py: 3, mt: 'auto' }}>
        <Container maxWidth="xl">
          <Typography variant="body2" color="text.secondary" align="center">
            Built by the talented students at Carnegie Mellon University:
            {' '}
            {[
              { name: 'Albert Han', url: 'https://www.linkedin.com/in/albertwrhan/' },
              { name: 'Jiamin Cai', url: 'https://www.linkedin.com/in/jasmine-cai-cuhk/' },
              { name: 'Yutong Bai', url: 'https://www.linkedin.com/in/yutong-bai/' },
              { name: 'Shreya Gupta', url: 'https://www.linkedin.com/in/sg-shreyagupta/' },
              { name: 'Vaibhavi Udgirkar', url: 'https://www.linkedin.com/in/vaibhavi-udgirkar/' },
            ].map((person, index, array) => (
              <><Box
                key={person.name}
                component="a"
                href={person.url}
                target="_blank"
                rel="noopener noreferrer"
                sx={{ color: 'inherit', textDecoration: 'underline' }}
              >
                {person.name}
              </Box>
                {index < array.length - 1 ? ', ' : '.'}
              </>
            ))}
          </Typography>
        </Container>
      </Box>
    </Box>
  );
};

export default Dashboard;
